/**
 * Horizon-safe SuperVIP Coupon Controller
 * - Works across AJAX variant re-renders
 * - Updates instantly on variant change
 * - Resets checkbox when hidden
 */
document.addEventListener("DOMContentLoaded", () => {
  const TARGET_VARIANT_TITLE = "2 Books"; // adjust if variant title differs

  function initSuperVipWatcher() {
    const couponDiv = document.querySelector("#supervip-coupon");
    if (!couponDiv) return; // not on super-vip template

    const checkbox = couponDiv.querySelector(".enable-coupon-checkbox");

    // Find latest product JSON (Shopify automatically injects this)
    const productJSON = document.querySelector('script[id="supervip-product-json"]');
    if (!productJSON) {
      console.warn("SuperVIP: no product JSON found yet");
      return;
    }

    let productData = null;
    try {
      productData = JSON.parse(productJSON.textContent);
    } catch (err) {
      console.warn("SuperVIP: failed to parse product JSON", err);
      return;
    }

    // Locate the 2 Books variant ID
    const targetVariant = productData.variants.find(
      (v) => v.title.trim().toLowerCase() === TARGET_VARIANT_TITLE.toLowerCase()
    );
    const targetVariantId = targetVariant ? String(targetVariant.id) : null;
    if (!targetVariantId) {
      console.warn("SuperVIP: variant not found:", TARGET_VARIANT_TITLE);
      return;
    }

    // Core logic
    function toggleCoupon() {
      const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const selectedId = variantInput ? variantInput.value : null;

      if (selectedId === targetVariantId) {
        couponDiv.style.display = "block";
      } else {
        couponDiv.style.display = "none";
        if (checkbox) checkbox.checked = false;
      }
    }

    // Run immediately once DOM is ready
    toggleCoupon();

    // Observe all section updates (Horizon rebuilds forms)
    document.addEventListener("shopify:section:load", toggleCoupon);
    document.addEventListener("shopify:section:unload", toggleCoupon);

    // Horizon sometimes dispatches these on the product section
    document.addEventListener("variant:change", toggleCoupon);
    document.addEventListener("variant:changed", toggleCoupon);

    // Fallback watcher — poll every 300ms to catch silent variant updates
    let lastVariantId = null;
    setInterval(() => {
      const variantInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      const currentVariantId = variantInput ? variantInput.value : null;

      if (currentVariantId && currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        toggleCoupon();
      }
    }, 300);
  }

  // Run when DOM first loads
  initSuperVipWatcher();

  // Also rerun when any section re-renders (important for Horizon)
  document.addEventListener("shopify:section:load", initSuperVipWatcher);
});
